const $ = window.jQuery

export function initAccountRecoveryToggle() {
  const $toggle = $('[data-toggle-account-recovery]');
  $toggle.click(function (e) {
    e.preventDefault();
    $('.login-form').toggleClass('show')
    $('.reset-password-form').toggleClass('show')
  });

  $('.reset-password-form__success').appendTo('.customer-messages');
  $('.errors').children().appendTo('.customer-messages').addClass('errors');
}

